import React from 'react';
import { Star, ShieldCheck, CreditCard, Send } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { CtaButton } from '../CtaButton';
import { offerItems, offerTotal } from '../../data/content';
import { siteConfig } from '../../data/siteConfig';
const payBadges = [{
  icon: ShieldCheck,
  label: 'Pago 100% seguro'
}, {
  icon: CreditCard,
  label: 'Tarjeta de crédito o débito'
}, {
  icon: Send,
  label: 'Entrega por email'
}];
export function OfferSection() {
  return <section id="oferta" className="scroll-mt-4 bg-forest py-16 md:py-[90px]" data-id="element-146" data-mp="1ox04r7m5d0h">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-147" data-mp="3sxub2tmzl5d7">
        <SectionHeading tone="dark" kicker="La oferta" icon={Star} title={<>
              Todo el kit, por menos de lo que
              <br className="hidden md:block" data-id="element-149" data-mp="3j0pncpdht1ua" /> cobras por <em data-id="element-150" data-mp="3ewhz0tay5nwl">un par de paseos</em>
            </>} data-id="element-148" data-mp="3sugc7vdj7eai" />
        <Reveal className="mx-auto mt-10 max-w-[640px] overflow-hidden rounded-[32px] bg-white text-ink shadow-[0_40px_80px_-30px_rgba(0,0,0,.6)]" data-id="element-151" data-mp="1as0n02sn5izy">
          <div className="bg-tangerine py-3 text-center font-display text-sm font-bold uppercase tracking-[0.1em] text-white" data-id="element-152" data-mp="1fjiocryktllg">
            Precio de lanzamiento
          </div>
          <div className="px-5 pb-1.5 pt-6 md:px-[30px]" data-id="element-153" data-mp="15se6nkhinmmx">
            <ul data-id="element-154" data-mp="15quplro1d7k3">
              {offerItems.map(({
              icon: Icon,
              label,
              value
            }) => {
              const included = value === 'Incluidos';
              return <li key={label} className="flex items-center justify-between gap-4 border-b border-dashed border-line py-[13px] text-[14.5px] md:text-base" data-id="element-155" data-mp="1yga6gy2dtunx">
                    <span className="flex items-center gap-2.5 font-medium" data-id="element-156" data-mp="1ohm0ixno960l">
                      <Icon className="h-[18px] w-[18px] shrink-0 text-tangerine" aria-hidden="true" data-id="element-157" data-mp="91vlmouhirxp" />
                      {label}
                    </span>
                    <span className={`whitespace-nowrap font-display font-semibold ${included ? 'uppercase text-forest' : 'text-muted'}`} data-id="element-158" data-mp="2fqnrbh1cuw32">
                      {value}
                    </span>
                  </li>;
            })}
            </ul>
            <div className="flex justify-between gap-4 pb-1 pt-4 font-display font-bold text-muted" data-id="element-159" data-mp="211rbuywyygsf">
              <span data-id="element-160" data-mp="1x1qy7ghp29mf">Valor estimado si lo armaras por separado</span>
              <s className="whitespace-nowrap text-danger" data-id="element-161" data-mp="1s0b8vc8hhgy8">{offerTotal}</s>
            </div>
          </div>
          <div className="bg-cream px-5 pb-8 pt-5 text-center md:px-[30px]" data-id="element-162" data-mp="1n31erja5gh42">
            <p className="font-display text-[15px] font-semibold text-muted" data-id="element-163" data-mp="1i3yjgqjz1p9a">Hoy te lo llevas todo por</p>
            <p className="my-1.5 font-display text-[56px] font-extrabold leading-none tracking-[-0.03em] text-forest md:text-[78px]" data-id="element-164" data-mp="3hf80vd4l0ib5">
              <small className="mr-1.5 align-[0.95em] text-[0.38em] text-tangerine" data-id="element-165" data-mp="3chzef0cehs43">{siteConfig.priceCurrency}</small>
              {siteConfig.priceAmount}
            </p>
            <p className="mb-6 text-[15px] font-semibold text-tangerine" data-id="element-166" data-mp="3oyqsg7rw5jvc">
              Pago único · Acceso inmediato · Para siempre
            </p>
            <CtaButton size="lg" data-id="element-167" data-mp="3tsv0kucw7xy0">¡Sí, quiero mi kit PASEO PRO!</CtaButton>
            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-168" data-mp="2jfpvlbnf98m">
              {payBadges.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-line bg-white px-2.5 py-[5px] text-xs font-bold text-muted" data-id="element-169" data-mp="360y0u1mpwwd9">
                  <Icon className="h-[13px] w-[13px]" aria-hidden="true" data-id="element-170" data-mp="3fzn68uxfgocm" />
                  {label}
                </li>)}
            </ul>
            <p className="mt-4 text-[14.5px] text-muted" data-id="element-171" data-mp="q9jwm1k4vp3u">
              Con <b data-id="element-172" data-mp="v7tq87q7mhnc">un solo cliente</b> que no cancele a último momento, el kit ya se pagó solo.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}